import { render, staticRenderFns } from "./EvaluationStarRatingCell.vue?vue&type=template&id=ff2aae36&scoped=true&"
import script from "./EvaluationStarRatingCell.vue?vue&type=script&lang=js&"
export * from "./EvaluationStarRatingCell.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationStarRatingCell.vue?vue&type=style&index=0&id=ff2aae36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2aae36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
